import { render } from "./RequestForQuotation.vue?vue&type=template&id=7150f5dd&scoped=true"
import script from "./RequestForQuotation.vue?vue&type=script&lang=js"
export * from "./RequestForQuotation.vue?vue&type=script&lang=js"

import "./RequestForQuotation.vue?vue&type=style&index=0&id=7150f5dd&scoped=true&lang=css"
import "./RequestForQuotation.vue?vue&type=style&index=1&id=7150f5dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7150f5dd"]])

export default __exports__